import React from 'react'
import {Icon} from '@chakra-ui/react'

const SendIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" id="send" {...props}>
            <path
                d="M12.3625 25.4989C11.9887 25.4989 11.6148 25.3587 11.3345 25.069L4.92317 18.6577C4.57737 18.3119 4.41849 17.8072 4.50261 17.3212C4.58672 16.8353 4.89513 16.4147 5.34374 16.2091L36.7646 1.10611C37.2319 0.881813 37.7833 1.022 38.0731 1.44257C38.3721 1.86313 38.3254 2.42389 37.9703 2.79772L24.8393 16.0409L13.2597 25.1905C12.998 25.3961 12.6803 25.4989 12.3625 25.4989ZM6.59609 17.6951L12.3999 23.4989L23.643 14.6203L33.316 4.85382L6.59609 17.6951Z"
                fill="currentColor"
            />
            <path
                d="M21.6616 34.9009C21.2597 34.9009 20.8672 34.742 20.5868 34.4523L14.1755 28.041C13.6521 27.5176 13.6054 26.6952 14.0634 26.1158L23.2878 14.4521L36.4468 1.41455C36.8113 1.05006 37.3814 1.00333 37.8019 1.3024C38.2225 1.60147 38.3627 2.15288 38.1384 2.62017L23.0261 34.0411C22.8111 34.4803 22.3999 34.7981 21.9139 34.8822C21.8298 34.9009 21.7457 34.9009 21.6616 34.9009ZM15.755 26.9849L21.5588 32.7887L34.4094 6.06881L24.6429 15.7418L15.7643 26.9849H15.755Z"
                fill="currentColor"
            />
            <path
                d="M16.7739 30.4896H16.7552L10.5028 30.3961C9.82052 30.3868 9.27846 29.8447 9.26911 29.1625L9.14762 22.4801C9.13827 21.9661 9.54949 21.5362 10.0635 21.5269H10.0822C10.5869 21.5269 11.0075 21.9381 11.0168 22.4428L11.1289 28.5363L16.7926 28.6204C17.3066 28.6204 17.7178 29.0503 17.7085 29.5737C17.7085 30.0877 17.2879 30.4896 16.7739 30.4896Z"
                fill="currentColor"
            />
            <path
                d="M6.81023 33.7233C6.57658 33.7233 6.33359 33.6298 6.15601 33.4523C5.79152 33.0878 5.78218 32.499 6.14667 32.1345L8.128 30.1251C8.49249 29.7606 9.08128 29.7513 9.44577 30.1158C9.81026 30.4803 9.81961 31.0691 9.45512 31.4336L7.47379 33.4429C7.28687 33.6298 7.05322 33.7233 6.81023 33.7233Z"
                fill="currentColor"
            />
            <path
                d="M1.9323 38.742C1.69865 38.742 1.45566 38.6485 1.27809 38.4709C0.913595 38.1065 0.904249 37.5177 1.26874 37.1532L3.25007 35.1438C3.61456 34.7793 4.20335 34.77 4.56784 35.1345C4.93233 35.499 4.94168 36.0877 4.57719 36.4522L2.59586 38.4616C2.40894 38.6485 2.17529 38.742 1.9323 38.742Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default SendIcon
